import React from 'react';
import { Typography } from '@mui/material';

export default function Results() {
  return (
    <div className="App-header">
      <Typography variant="h4" component="h1" gutterBottom>
        Results
      </Typography>
    </div>
  );
}